export default __webpack_public_path__ + "static/media/undo-icon-disabled.b5481279.svg";